const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null && value !== '');
const numeric = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const aliasKeys = new Set([
  'orderitemid', 'decorationid', 'chargeid', 'quantity', 'netcost', 'unitcost', 'total',
  'currencycode', 'decoratorid', 'supplierid', 'addressid', 'sharedgroupkey',
  'rowindex', 'productiondepartmentid',
]);

const stableValue = (value) => {
  if (Array.isArray(value)) return value.map(stableValue);
  if (value && typeof value === 'object') {
    return Object.keys(value).sort().reduce((result, key) => {
      result[key] = stableValue(value[key]);
      return result;
    }, {});
  }
  return value ?? null;
};

export const purchaseOrderChargeIdentity = (charge = {}) => JSON.stringify({
      orderItemId: firstDefined(charge.orderItemId, charge.OrderItemId),
      decorationId: firstDefined(charge.decorationId, charge.DecorationId),
      chargeId: firstDefined(charge.chargeId, charge.ChargeId, charge.id, charge.Id),
      rowIndex: firstDefined(charge.rowIndex, charge.RowIndex),
      decoratorId: firstDefined(charge.decoratorId, charge.DecoratorId),
      supplierId: firstDefined(charge.supplierId, charge.SupplierId),
      addressId: firstDefined(charge.addressId, charge.AddressId),
      sharedGroupKey: firstDefined(charge.sharedGroupKey, charge.SharedGroupKey),
      quantity: numeric(firstDefined(charge.Quantity, charge.quantity)),
      netCost: numeric(firstDefined(charge.NetCost, charge.netCost, charge.UnitCost, charge.unitCost)),
      total: numeric(firstDefined(charge.Total, charge.total)),
      currencyCode: firstDefined(charge.CurrencyCode, charge.currencyCode),
      productionDepartmentId: firstDefined(charge.productionDepartmentId, charge.ProductionDepartmentId),
      other: Object.keys(charge).sort().reduce((result, field) => {
        if (!aliasKeys.has(field.toLowerCase())) result[field] = stableValue(charge[field]);
        return result;
      }, {}),
    });

export const normalizePurchaseOrderCharges = (charges = []) => {
  if (!Array.isArray(charges)) return [];
  const seen = new Set();
  return charges.filter((charge) => {
    if (!charge || typeof charge !== 'object') return true;
    const key = purchaseOrderChargeIdentity(charge);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
